module.exports = __webpack_public_path__ + "fonts/fa-duotone-900.4bd9f12.eot";